import VideoService from '@/services/videoservice'
// init state
const state = {
  categories: {},
  video: {},
  videos: [],
  dispVideos: [],
  sortBy: ''
}
// getters
const getters = {
  getCategories: state => state.categories,
  getVideos: state => state.videos,
  getDispVideos: state => state.dispVideos,
  getSort: state => state.sortBy
}
// actions
const actions = {
  async fetchVideoCategories (context) {
    await VideoService.getCategories()
      .then(response => {
        context.commit('setCategories', response.data)
      })
  },
  async fetchVideos (context) {
    await VideoService.getVideos()
      .then(response => {
        context.commit('setVideos', response.data)
      })
  },
  async filterVideos ({ commit, state }, { searchQuery, category, onlyPremium }) {
    let filtered = state.videos.filter(video => {
      const matchTitleOrDesc = !searchQuery ||
        (video.title && video.title.includes(searchQuery)) ||
        (video.desc && video.desc.includes(searchQuery))

      const matchCategory = !category || video.category === Number(category)

      const matchPremium = !onlyPremium || (onlyPremium === 'true' && video.isTargetPremium)

      return matchTitleOrDesc && matchCategory && matchPremium
    })

    commit('setFilteredVideos', filtered)

    await this.dispatch('sortVideos')
  },
  async sortVideos ({ commit, state }) {
    const sorted = [...state.dispVideos].sort((a, b) => b.id - a.id)
    switch (state.sortBy) {
      case 'comments':
        sorted.sort((a, b) => b.comments - a.comments)
        break
      case 'likes':
        sorted.sort((a, b) => b.likes - a.likes)
        break
      default:
        break
    }
    commit('setFilteredVideos', sorted)
  }
}
// mutations
const mutations = {
  setCategories (state, categories) {
    state.categories = categories
  },
  setVideos (state, videos) {
    state.videos = videos
    state.dispVideos = videos
  },
  setFilteredVideos (state, dispVideos) {
    state.dispVideos = dispVideos
  },
  setSortVideos (state, sortBy = '') {
    state.sortBy = sortBy
  },
  clearStore (state) {
    state.categories = []
    state.video = {}
    state.videos = []
    state.dispVideos = []
    state.sortBy = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/video.js